/*
 * @Author: changcheng
 * @LastEditTime: 2024-04-07 13:37:58
 */
import { useEffect, useState, useRef } from "react";
import {
  Modal,
  Button,
  Space,
  Form,
  Input,
  Select,
  ConfigProvider,
  message,
  TreeSelect,
  Cascader,
} from "antd";
import {
  getRegisterInstituteList,
  getSubjectList,
  getUserInfoByPhoneNum,
  queryRegister,
  queryReportConfirm,
  queryReportRegister,
  reportConfirm,
  validatePhoneNumber,
  getInstituteList_new,
} from "@root/common/service";
import { validatorIdCard } from "@root/common/utils";
import zhCN from "antd/es/locale/zh_CN";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@root/store/index";
import {
  postDic,
  sexDic,
  cardTypeDic,
  hospitalCenterDic,
  professionalTitleDic,
  subjectDic,
  confirmUserInfoTitle,
  registerSuccessText,
  confirmSubmitText,
} from "@root/common/data/dic";
import ShowConfirm from "@root/pages/index/showConfirm";
import wechatService from "@root/img/wechatService.png";
const { Option } = Select;

const handleSubjectDic: any = (subjectDic: any[]) => {
  return subjectDic.map((item) => {
    return {
      value: item.value,
      label: item.title,
      children: item.children ? handleSubjectDic(item.children) : [],
    };
  });
};
const subjectCascaderData = handleSubjectDic(subjectDic);
interface LoginPropsType {
  showConfirmUserInfo: Boolean;
  /**设置注册modal的set方法*/
  setShowConfirmUserInfo: <T extends boolean>(type: T) => void;
}
interface HospitalListPropsType {
  /**医院id */
  id: number;
  /**医院名称 */
  name: string;
}
export default function Register<T extends LoginPropsType>(props: T) {
  console.log("subjectCascaderData", subjectCascaderData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formRef = useRef<any>();
  const { centerClassification = [] } = useSelector(
    (state: RootState) => state.directionaries
  );
  const { userName = "" } = useSelector((state: RootState) => state.userInfo);
  const registerType = useSelector((state: RootState) => state.registerType);
  const { showConfirmUserInfo, setShowConfirmUserInfo } = props;
  const [hospitalList, setHospital] = useState<HospitalListPropsType[]>([]); // 医院列表
  const [isCountyDoctor, setIsCountyDoctor] = useState("");
  const [instituteId, setInstituteId] = useState("");
  const [userId, setUserId] = useState("");
  // 判断信息是否是完全的， 2：补全 0:全
  const [confirmFlag, setConfirmFlag] = useState("");
  // 判断信息是否存在
  const [accountAlready, setAccountAlready] = useState(false);
  /**
   * 通过省份获取医院
   * @param value
   */
  const getHospitalByProvinceData = async (value: any[]) => {
    const { data } = await getInstituteList_new();
    setHospital(data);
  };
  /**
   * 获取用户已填写的用户信息
   */
  const queryUserInfoByPhoneNum = async () => {
    const { data } = await validatePhoneNumber(userName);
    setAccountAlready(data);
    // 如果手机号已经存在
    if (data) {
      const { data } = await getUserInfoByPhoneNum(userName);
      // 兼容Null的情况
      for (let key in data) {
        if (!data[key]) {
          data[key] = "";
        }
      }
      const {
        centerCategoryList,
        instituteId,
        userId,
        confirmFlag,
        townshipFalg,
        subjectId,
      } = data;
      setInstituteId(instituteId);
      setUserId(userId);
      setConfirmFlag(confirmFlag);
      setIsCountyDoctor(townshipFalg);
      formRef.current.setFieldsValue({
        ...data,
        centerCategoryList: centerCategoryList ? centerCategoryList : [],
        subjectId: handleSubjectId(subjectId),
      });
    }
  };
  // 查找一级学科分类
  const handleSubjectId = (subjectId: any) => {
    let subjectParentId = "";
    subjectCascaderData.forEach((element: any) => {
      element.children.forEach((it: any) => {
        if (it.value === subjectId) {
          subjectParentId = element.value;
          return;
        }
      });
    });
    return [subjectParentId, subjectId];
  };
  const querySubjectList = async () => {
    await getSubjectList();
  };
  useEffect(() => {
    if (showConfirmUserInfo) {
      getHospitalByProvinceData(["110000", "110100", "110101"]);
      querySubjectList();
      queryUserInfoByPhoneNum();
    }
  }, [showConfirmUserInfo]);
  /**
   *  注册用户
   * @param values
   * @returns
   */
  const onFinish = async (values: any) => {
    const { identityNumber, baseUserIdCategory, subjectId } = values;
    if (baseUserIdCategory === "0" && !validatorIdCard(identityNumber)) {
      message.info("身份证号码不符合规则");
      return;
    }
    const successText = registerSuccessText.get(registerType);
    // 转为数组格式
    values.centerCategoryList = [...values.centerCategoryList];
    // 传手机号
    values.phonenumber = userName;
    // 保存用户名
    values.userName = userName;
    // 学科
    values.subjectId = subjectId.pop();
    // 注册进入
    if (registerType === "register") {
      const { code, msg } = await queryRegister(values);
      if (code === 200) {
        Modal.success({
          content: successText,
        });
        setShowConfirmUserInfo(false);
        navigate("/login");
      } else {
        message.error(msg);
      }
    }
    // banner进入
    if (registerType === "banner") {
      // 信息存在
      if (accountAlready) {
        values = {
          ...values,
          userId,
        };
        const { code, msg } = await queryReportConfirm(values);
        if (code === 200) {
          Modal.success({
            content: successText,
          });
          setShowConfirmUserInfo(false);
        } else {
          message.error(msg);
        }
      } else {
        const { code, msg } = await queryReportRegister(values);
        if (code === 200) {
          Modal.success({
            content: successText,
          });
          setShowConfirmUserInfo(false);
        } else {
          message.error(msg);
        }
      }
    }
    // 登录进入
    if (registerType === "login") {
      values = {
        ...values,
        userId,
      };
      const { code, msg } = await reportConfirm(values);
      if (code === 200) {
        message.success("补全信息成功");
        setShowConfirmUserInfo(false);
        navigate("/home/index");
      } else {
        message.error(msg);
      }
    }
  };
  return (
    <div>
      <Modal
        title={`${confirmUserInfoTitle.get(registerType)}`}
        visible={showConfirmUserInfo as any}
        footer={null}
        onCancel={() => {
          setShowConfirmUserInfo(false);
        }}
        destroyOnClose={true}
        closable={false}
        maskClosable={false}
      >
        <ConfigProvider locale={zhCN}>
          <Form
            name="basic"
            initialValues={{
              countyHospitalType: "",
              technicalTitle: "",
              subjectType: "",
            }}
            onFinish={onFinish}
            autoComplete="off"
            style={{
              width: "360px",
              margin: "0 auto",
            }}
            ref={formRef}
          >
            <Form.Item
              name="nickName"
              rules={[{ required: true, message: "请输入姓名" }]}
            >
              <Input placeholder="请输入姓名" maxLength={30} />
            </Form.Item>
            <Form.Item
              name="sex"
              rules={[{ required: true, message: "请选择性别" }]}
            >
              <Select placeholder="请选择性别">
                {sexDic.map((item) => (
                  <Option value={item.value}>{item.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="baseUserIdCategory"
              rules={[{ required: true, message: "请选择证件类型" }]}
            >
              <Select placeholder="请选择证件类型">
                {cardTypeDic.map((item) => (
                  <Option value={item.value}>{item.name}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="identityNumber"
              rules={[{ required: true, message: "请输入证件号码" }]}
            >
              <Input placeholder="请输入证件号码" maxLength={18} />
            </Form.Item>
            <Form.Item
              name="townshipFalg"
              rules={[{ required: true, message: "请选择是否为乡镇(村)医生" }]}
              style={{
                margin: "0 0 2px",
              }}
            >
              <Select
                placeholder="是否为乡镇(村)医生"
                onChange={(val) => {
                  setIsCountyDoctor(val);
                }}
              >
                <Option value="0">是</Option>
                <Option value="2">否</Option>
              </Select>
            </Form.Item>
            <br />
            <Form.Item
              name="instituteId"
              rules={[
                { required: true, message: "请选择您所在的单位名称(可搜索)" },
              ]}
              style={{
                margin: "0 0 2px",
              }}
            >
              <Select
                placeholder="请选择您所在的单位名称(可搜索)"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option!.children as unknown as string).includes(input)
                }
                filterSort={(optionA, optionB) =>
                  (optionA!.children as unknown as string)
                    .toLowerCase()
                    .localeCompare(
                      (optionB!.children as unknown as string).toLowerCase()
                    )
                }
              >
                {hospitalList.map((it) => (
                  <Option key={it.id} value={it.id}>
                    {it.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <span
              className="red"
              style={{
                margin: "12px 0 ",
              }}
            >
              {registerType === "banner" ? (
                <>
                  注：若您搜索不到自己的机构，请扫描下方二维码添加小助手，进行人工报名。
                </>
              ) : (
                <>
                  注：如果医疗机构搜索不到,请联系技术支持电话：400-001-001-8080。
                </>
              )}
            </span>
            <Form.Item
              name="subjectId"
              rules={[{ required: true, message: "请选择您的学科" }]}
            >
              <Cascader
                options={subjectCascaderData}
                placeholder="请选择您的学科"
              />
            </Form.Item>
            <Form.Item
              name="centerCategoryList"
              style={{
                margin: "0 0 2px",
              }}
              rules={[
                { required: true, message: "请选择您的中心类别(可搜索)" },
              ]}
            >
              <Select placeholder="请选择您的中心类别(可搜索)">
                {hospitalCenterDic.map((item) => (
                  <Option value={item.value}>{item.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <br />
            <Form.Item
              name="baseHealthTitle"
              rules={[{ required: true, message: "请选择您的职称" }]}
            >
              <Select placeholder="请选择您的职称">
                {professionalTitleDic.map((item) => (
                  <Option value={item.value}>{item.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="postId"
              rules={[{ required: true, message: "请选择您的职务" }]}
            >
              <Select placeholder="请选择您的职务">
                {postDic.map((item) => (
                  <Option value={item.value}>{item.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Space>
                <Button type="primary" htmlType="submit">
                  {confirmSubmitText.get(registerType)}
                </Button>
              </Space>
            </Form.Item>
            {registerType === "banner" && (
              <p style={{ textAlign: "center" }}>
                <img src={wechatService} alt="" width={"200px"} />
              </p>
            )}
          </Form>
        </ConfigProvider>
      </Modal>
    </div>
  );
}
